import config from 'src/config';

/**
 * Shared attributes added to each `track` properties or `identify`  traits
 * call. For now, it returns the app version.
 */
export default {
  appVersion: config('app.version'),
};
